import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';
import { requestLogModel } from '@/models/api/requestLog.model';

export const errorLogModel = (data) => ({
    uuid: data.uuid,
    level: data.level,
    exceptionClass: data.exception_class,
    message: data.message,
    exceptionCode: data.exception_code,
    sourceFile: data.source_file,
    sourceLine: data.source_line,
    stackTrace: data.stack_trace,
    previous_exception: data.previous_exception,
    performance: data.performance ? {
        memoryUsageMb: data.performance?.memory_usage_mb,
        memoryPeakMb: data.performance?.memory_peak_mb,
        uptimeMs: data.performance?.uptime_ms,
    } : null,
    hostname: data.hostname,
    context: data.context,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    updatedAt: filtersHelper.getDateTimeFormat(data.updated_at),
    user: data.user ? userModel(data.user) : null,
    requestLog: data.request_log ? requestLogModel(data.request_log) : null,
});
